var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 68.7363C53.981 68.7363 69.3682 53.3492 69.3682 34.3681C69.3682 15.3871 53.981 0 35 0C16.019 0 0.631836 15.3871 0.631836 34.3681C0.631836 53.3492 16.019 68.7363 35 68.7363Z",
    fill: "#007BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9211 19.8621C52.3543 20.2165 45.9348 28.8545 37.5857 39.1466L32.5184 45.2903L31.8227 46.1305L31.0875 45.3691C24.5237 38.6346 20.0997 33.6461 20.4147 33.3311C20.7298 33.016 25.7314 37.4663 32.4528 43.9907L31.035 44.1351L35.9972 37.9257C44.3464 27.568 51.4747 19.5076 51.9211 19.8621Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.b0cd72f524a282811ddefde398aae423.svg";
export { ForwardRef as ReactComponent };